<div class="result-container">
  <div class="result-container-header">
    <div class="w-full overflow-hidden overflow-ellipsis whitespace-nowrap">
      <h3>{{declinedOperation.serviceGroupDescription ? declinedOperation.serviceGroupDescription : ''}}</h3>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="result-container-content">
    <div class="result-container-content-line"
      *ngIf="browserControlCommunicationService.drilldownEnabled else noDrilldownEnabled">
      <span class="mat-body-2 card-line-1">Declined on RO <a style="color: rgb(0,0,238);cursor: pointer"
          (click)="browserControlCommunicationService.drilldown('powerlane', 'w_work_order_entry_new', [declinedOperation.workOrderId.toString()])"
          class="mat-body-1">(ID: {{ declinedOperation.workOrderId }})</a> on
        {{declinedOperation.dateOpened | date: 'M/d/yy'}}</span>
    </div>
    <ng-template #noDrilldownEnabled>
    <div class="result-container-content-line">
      <span class="mat-body-2 card-line-1">Declined on RO (ID: {{ declinedOperation.workOrderId }}) on
        {{declinedOperation.dateOpened | date: 'M/d/yy'}}</span>
    </div>
    </ng-template>
    <div class="result-container-content-line">
      <div *ngIf="declinedOperation.action; else notActioned">
        <span class="mat-body-2 card-line-1">Actioned</span>
        <span class="mat-body-2 card-line-1" *ngIf="declinedOperation.actionDate"> on
          {{declinedOperation.actionDate | date: 'M/d/yy'}}</span><span class="mat-body-2 card-line-1"
          *ngIf="declinedOperation.actionTypeDescription"> via
          {{declinedOperation.actionTypeDescription}}</span>
      </div>
      <ng-template #notActioned>
        <div>
          <span class="mat-body-2 card-line-1">Not actioned</span>
        </div>
      </ng-template>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span>
        {{declinedOperation.vehicleYear}} {{declinedOperation.vehicleMake}} {{declinedOperation.vehicleDescription}}
      </span>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span>
        Owned by {{declinedOperation.customerFirstName}}
        {{declinedOperation.customerLastName}} (ID: {{declinedOperation.associateId}})</span>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span *ngIf="declinedOperation.messagePreferenceDescription; else noMessagePreference">
        Message preference of {{declinedOperation.messagePreferenceDescription}}</span>
      <ng-template #noMessagePreference>
        <span>No message preference</span>
      </ng-template>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span>
        C: {{declinedOperation.cellPhoneNumber | phoneNumber}}, H: {{declinedOperation.homePhoneNumber |
        phoneNumber}}</span>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span *ngIf="declinedOperation.emailAddress; else noEmail">
        {{declinedOperation.emailAddress}}</span>
      <ng-template #noEmail>
        <span>No email available</span>
      </ng-template>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span><span>
          {{declinedOperation.serviceGroupCategory ? declinedOperation.serviceGroupCategory : 'No category
          set'}}</span></span>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span>Service was
        {{declinedOperation.stated === "Explicit" ? 'explicitly' : declinedOperation.stated === "Implied" ? 'implicitly'
        : ''}}
        declined
        for
        {{ declinedOperation.reason ? declinedOperation.reason : 'No Reason' }}
      </span>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>
      <span>
        Service advisor was {{declinedOperation.serviceAdvisorFirstName}} {{declinedOperation.serviceAdvisorLastName}}
      </span>
    </div>
    <div class="result-container-content-line">
      <span class="primary-bullet">·
      </span>

      <a *ngIf="declinedOperation.url !== null; else noRepairOrderDetails" [href]="declinedOperation.url"
        target="_blank" rel="noopener">Repair order details</a>
      <ng-template #noRepairOrderDetails>
        <span>
          No repair order details available
        </span>
      </ng-template>
    </div>
  </div>
</div>